export const VOUCHERS_RESET_STATE = 'VOUCHERS_RESET_STATE';
export const VOUCHERS_CURRENT_ITEM = 'VOUCHERS_CURRENT_ITEM';

export const VOUCHERS_REQUEST_LOADING = 'VOUCHERS_REQUEST_LOADING';
export const VOUCHERS_REQUEST_SUCCESS = 'VOUCHERS_REQUEST_SUCCESS';
export const VOUCHERS_REQUEST_FAILED = 'VOUCHERS_REQUEST_FAILED';

export const VOUCHERS_CURRENT_ACTION = 'VOUCHERS_CURRENT_ACTION';
export const VOUCHERS_RESET_ACTION = 'VOUCHERS_RESET_ACTION';